import { serializable } from 'serializr';
import { computed, observable } from 'mobx';
import WatchAgentBase from './../shared/watchagent-base';

export default class WatchAgentModel extends WatchAgentBase {
    constructor() {
        super();
    }
    @serializable @observable agentProfile = { preferences: '', preferredEmail: '', notes: '' };
    @computed
    get profile() {
        return this.agentProfile;
    }
}



// WEBPACK FOOTER //
// ./src/agents/watchagent-model.js